import React from 'react'

export default function Loader ({ loading, inButton, text }) {
  return (
        <div className={inButton ? 'loader-button' : 'loader'} style={{ display: loading ? 'block' : 'none' }}>{text || 'Cargando...'}</div>
  )
}
